import type { UseFetchInterfaceAppResourcesHookType } from '@unifyapps/carbon/no-code/hooks/fetchAndInvalidation/types';
import {
  InterfaceResourceStrategies,
  type InterfaceResourceStrategyType,
} from '../../../../context/InterfaceResourceStrategyProvider/constants';
import useCachedInterfaceAppResources from '../../../../hooks/fetchAndInvalidation/cachedEntities/app/useCachedInterfaceAppResources';
import useFetchAuthDeployedInterfaceAppResources from '../../../../hooks/fetchAndInvalidation/deployedEntities/data/app/useFetchAuthDeployedInterfaceAppResources';
import useFetchDeployedInterfaceAppResources from '../../../../hooks/fetchAndInvalidation/deployedEntities/data/app/useFetchDeployedInterfaceAppResources';
import useFetchPlatformAuthDeployedInterfaceAppResources from '../../../../hooks/fetchAndInvalidation/deployedEntities/data/app/useFetchPlatformAuthDeployedInterfaceAppResources';
import useFetchDeployedInterfaceAppResourcesByVersion from '../../../../hooks/fetchAndInvalidation/deployedEntities/dataByVersion/app/useFetchDeployedInterfaceAppResourcesByVersion';
import useFetchSavedInterfaceAppResourcesByVersion from '../../../../hooks/fetchAndInvalidation/savedEntities/dataByVersion/app/useFetchSavedInterfaceAppResourcesByVersion';
import useFetchStandardInterfaceAppResources from '../../../../hooks/fetchAndInvalidation/standardEntities/data/app/useFetchStandardInterfaceAppResources';

export const APP_RESOURCES_STRATEGY_VS_HOOK: Record<
  InterfaceResourceStrategyType,
  UseFetchInterfaceAppResourcesHookType
> = {
  [InterfaceResourceStrategies.Deployed]: useFetchDeployedInterfaceAppResources,
  [InterfaceResourceStrategies.Authorization]: useFetchAuthDeployedInterfaceAppResources,
  [InterfaceResourceStrategies.PlatformAuthorization]:
    useFetchPlatformAuthDeployedInterfaceAppResources,
  [InterfaceResourceStrategies.Standard]: useFetchStandardInterfaceAppResources,
  [InterfaceResourceStrategies.CachedResources]: useCachedInterfaceAppResources,
  [InterfaceResourceStrategies.DeployedByVersion]: useFetchDeployedInterfaceAppResourcesByVersion,
  [InterfaceResourceStrategies.SavedByVersion]: useFetchSavedInterfaceAppResourcesByVersion,
};
